import type { Compra } from '../types/content'

export const compras: Compra[] = [
  { name: 'Marina', city: 'Buenos Aires, Argentina', product: 'MegaPack Cocina Proteica Lista' },
  { name: 'Camila', city: 'Santiago, Chile', product: 'MegaPack + El Método 80/20' },
  { name: 'Lucía', city: 'Montevideo, Uruguay', product: 'MegaPack Cocina Proteica Lista' },
  { name: 'Andrea', city: 'Bogotá, Colombia', product: 'MegaPack + El Método 80/20' },
  { name: 'Florencia', city: 'Rosario, Argentina', product: 'MegaPack Cocina Proteica Lista' },
  { name: 'Paola', city: 'Ciudad de México, México', product: 'MegaPack Cocina Proteica Lista' },
  { name: 'Gabriela', city: 'Lima, Perú', product: 'MegaPack + El Método 80/20' },
  { name: 'Verónica', city: 'Córdoba, Argentina', product: 'MegaPack Cocina Proteica Lista' },
  { name: 'Daniela', city: 'Asunción, Paraguay', product: 'MegaPack Cocina Proteica Lista' },
  { name: 'Carolina', city: 'Quito, Ecuador', product: 'MegaPack + El Método 80/20' },
  { name: 'Julieta', city: 'Mendoza, Argentina', product: 'MegaPack Cocina Proteica Lista' },
  { name: 'Rocío', city: 'Miami, Estados Unidos', product: 'MegaPack + El Método 80/20' },
  { name: 'Agustina', city: 'La Plata, Argentina', product: 'MegaPack Cocina Proteica Lista' },
  { name: 'Mariana', city: 'San José, Costa Rica', product: 'MegaPack Cocina Proteica Lista' },
  { name: 'Silvina', city: 'Madrid, España', product: 'MegaPack + El Método 80/20' },
]
